import type { FaireProductEntity } from "../../entity_types/product";

export const p_x6sfeubfmz: FaireProductEntity = {
  token: "p_x6sfeubfmz",
  type: "product",
  name: "Cool Moms Love Jesus Embroidery Sweatshirt",
  brandToken: "b_2btq7m6dwd",
  brandName: "D&E Threads",
  imageUrl:
    "https://cdn.faire.com/fastly/2a9bc88c06d0adecafc6c263a548a2efd8af2c76661755c65710ef555f0e4a88.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/faa616e06368fa3895f214cb36f05a7784e950d91c02c4917850b9b1cf543886.jpeg",
    "https://cdn.faire.com/fastly/9de75151231b558ee9046eb309393fec6e549276408dcdeb5365211043faf3c5.jpeg",
  ],
  priceDollars: 27.39,
  description:
    "Embroidery on a Gildan brand ash sweatshirt. Black thread. The cap is also available in another listing.",
  tags: [],
  msrpDollars: 54.79,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:53.300Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
